import { useState } from "react";
import { React } from "react-router-dom";
import { saveToLS, getFromLS } from "../utils/localstorage";

export default function Login() {
    const [textInput, setTextInput] = useState('');
    const [visible, setVisible] = useState(false);

    const handleInputChange = (e) => {
        setTextInput(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('submitted');

        saveToLS('sessiontoken', "ANewMuchLongerPassPhraseThatActsLikeASessionToken");

        // //TODO: working here (serverside)
        // fetch('https://www.nathan-beals.com/api/login', {method: 'GET', headers: {'passphrase':{textInput}}})
        // .then(response => 
        //     {
        //         saveToLS('sessionkey', response.json());
        //     })
        // .catch(error => console.error(error))
        // .finally(() => {console.log('request complete')});
    }

    const handleVisible = (e) => {
        e.preventDefault();
        setVisible(!visible);
    }
    

    return (
        <div>
            <button onClick={handleVisible}>🔒</button>
            <form id="login" onSubmit={handleSubmit} hidden={!visible}>
                <label> Enter Text: </label>
                <input type="text" value={textInput} onChange={handleInputChange} />
            </form>
        </div>
    )
}